import { t } from '@lingui/core/macro'
import { useRuntimeVariables } from 'app-kit'
import { useGeckoAuth } from 'features/auth'
import { useCallback, useState } from 'react'

/**
 * Delete one fim-sentinel via fim-service (scoped to the site partition).
 */
export const useDeleteSentinel = () => {
  const { FIM_SERVICE_URL } = useRuntimeVariables()
  const { authorizedAxios } = useGeckoAuth()
  const [deleting, setDeleting] = useState(false)
  const [error, setError] = useState<string | undefined>()

  const deleteSentinel = useCallback(
    async (site: string, entryId: string) => {
      setDeleting(true)
      setError(undefined)
      try {
        await authorizedAxios.delete(
          `${FIM_SERVICE_URL}/api/v1/sites/${encodeURIComponent(site)}/sentinel/${encodeURIComponent(entryId)}`
        )
      } catch (err) {
        const message =
          err instanceof Error ? err.message : t`Failed to delete sentinel`
        setError(message)
        throw err
      } finally {
        setDeleting(false)
      }
    },
    [FIM_SERVICE_URL, authorizedAxios]
  )

  return { deleteSentinel, deleting, error }
}
